const { q, qa } = require('../helpers.js');

export const divWrapper = q('#divWrapper');
export const lblLoader = q('#lblLoader');
export const divStep0 = q('.step-0');
export const divStep1 = q('.step-1');
export const divStep2 = q('.step-2');
export const divStep3 = q('.step-3');
export const divStep4 = q('.step-4');
export const divStep5 = q('.step-5');
export const infoDivs = qa('.info-msg');